export const ROOM_LIST = 'ROOM_LIST';
export const ROOM_SWITCHED = 'ROOM_SWITCHED';
export const ROOM_JOINED = 'ROOM_JOINED';
export const ROOM_LEAVED = 'ROOM_LEAVED';
export const ROOM_STAYED = 'ROOM_STAYED';
export const ROOM_DESTROYED = 'ROOM_DESTROYED';
export const ROOM_UPDATED = 'ROOM_UPDATED';
export const ROOM_INACTIVE = 'ROOM_INACTIVE';
export const VISIBLE_ROOM_SWITCHED = 'VISIBLE_ROOM_SWITCHED';
export const VISIBLE_ROOM_CLOSED = 'VISIBLE_ROOM_CLOSED';
export const ROOM_USER_SORTING_UPDATED = 'ROOM_USER_SORTING_UPDATED';
export const ROOM_SUBSCRIPTION_PAYMENT_FAILED = 'ROOM_SUBSCRIPTION_PAYMENT_FAILED';

export const ROOM_TYPE_PERMANENT = 'permanent';
export const ROOM_TYPE_VIRTUAL = 'virtual';
export const ROOM_TYPE_PERSONAL = 'personal';
export const ROOM_TYPE_PRIVATE = 'private';

export const ROOM_REFRESH_INTERVAL = 30*1000;


// WEBPACK FOOTER //
// ./src/constants/rooms.js